import { Component } from '@angular/core';

@Component({
  selector: 'app-rapid-files',
  templateUrl: './rapid-files.component.html',
  styleUrls: ['./rapid-files.component.scss']
})
export class RapidFilesComponent {

}
